import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { setDynamicDiscountAction } from 'root-redux/actions/common'

export const useDynamicDiscount = () => {
  const { search } = useLocation()
  const dispatch = useDispatch()
  const URLParams = new URLSearchParams(search)
  const utmTagsFromUrl = Object.fromEntries(URLParams.entries())

  useEffect(() => {
    if (
      utmTagsFromUrl.discount_checkout &&
      utmTagsFromUrl.discount_amount &&
      utmTagsFromUrl.discount_name &&
      utmTagsFromUrl.discount_theme
    ) {
      dispatch(
        setDynamicDiscountAction({
          amount: Number(utmTagsFromUrl.discount_amount),
          name: utmTagsFromUrl.discount_name,
          checkout: utmTagsFromUrl.discount_checkout,
          theme: utmTagsFromUrl.discount_theme,
        }),
      )
    }
  }, [
    dispatch,
    utmTagsFromUrl.discount_amount,
    utmTagsFromUrl.discount_checkout,
    utmTagsFromUrl.discount_name,
    utmTagsFromUrl.discount_theme,
  ])
}
